import configureStore from "./configure-store"
import history from "./utils/history"

// Create redux store with history
const initialState = {}
export const store = configureStore(initialState, history)
